import { Subject } from 'rxjs';
import { Component, OnInit, HostListener, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/guard/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {
  isAdmin: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop = true;

  langChange: Subject<string> = new Subject<string>();

  constructor(
    protected translate: TranslateService,
    protected authService: AuthService,
    private deviceService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    this.onResize();
    this.translate.onLangChange.subscribe(lg => {
      this.langChange.next(lg.lang);
    });
    this.authService.adminLoggedCast.subscribe(isAdminLogged => this.isAdmin = isAdminLogged);
    this.authService.isAdminLogged();
    this.isTablet = this.deviceService.isTablet();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktop = this.deviceService.isDesktop();
    if (route.snapshot.queryParams.lang) {
      this.translate.use(route.snapshot.queryParams.lang);
    }
  }

  ngOnInit(): void {
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    const width = window.outerWidth;

    if (width < 650) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
      return;
    }

    if (width <= 1100) {
      this.isMobile = false;
      this.isTablet = true;
      this.isDesktop = false;
      return;
    }

    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktop = this.deviceService.isDesktop();
  }

  setLanguage(lg: string) {
    this.translate.use(lg);
  }

}
